<template>
  <v-dialog
      overlay-color="grey darken-2"
      transition="scroll-x-transition"
      content-class="ec-confirmation-dialog"
      width="440"
      v-model="dialog"
      @change="handleDialogChange"
  >
    <v-card color="accent" width="440">
      <v-list color="accent">
        <p v-if="noProfilesExist" class="mb-3 pt-3 pl-4">
          Create a new user profile
        </p>
        <p v-else class="mb-3 pt-3 pl-4">Select a user profile</p>
        <v-divider></v-divider>
        <div style="max-height: 250px; overflow-y: auto">
          <v-list-item
              v-for="profile in profiles"
              :key="profile.id"
              @click="selectUserProfile(profile)"
              class="mb-0"
          >
            <v-list-item-avatar class="my-0">
              <v-icon
                  v-if="
                  profile.configuration.device == profileDeviceTypes.Desktop
                "
                  size="22"
              >fas fa-desktop
              </v-icon
              >
              <v-icon
                  v-else-if="
                  profile.configuration.device == profileDeviceTypes.Laptop
                "
                  size="22"
              >fas fa-laptop
              </v-icon
              >
              <v-icon
                  v-else-if="
                  profile.configuration.device == profileDeviceTypes.Mobile
                "
                  size="22"
              >fas fa-mobile-alt
              </v-icon
              >
              <v-icon
                  v-else-if="
                  profile.configuration.device == profileDeviceTypes.Tablet
                "
                  size="22"
              >fas fa-tablet-alt
              </v-icon
              >
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
              >{{ profile.configuration.device }}
                <div
                    v-if="isAdmin"
                    style="
                    position: absolute;
                    top: 14px;
                    left: 140px;
                    font-size: 12px;
                  "
                    class="mt-1 grey--text"
                >
                  ({{ profile.username }})
                </div>
                <!-- <div
                v-else-if="
                  profile.configuration.device == profileDeviceTypes.Desktop &&
                  !isMobileOrTablet
                "
                style="float: right; margin-right: 188px; font-size: 12px"
                class="mt-1 grey--text"
              >
                (Default) 
              </div> -->
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action style="margin-top: 6px; margin-bottom: 6px">
              <v-btn @click.stop="deleteProfileConfirmation(profile)" icon>
                <span style="font-size: 28px" class="icon-delete-21x21">
                  <span class="path1 letterSpacing0"></span>
                  <span class="path2" style="margin-left: -1px"></span>
                </span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>

        <v-list-item class="mb-0">
          <v-btn
              @click="addNewProfile"
              text
              class="remove-btn-text-transform"
              style="padding-left: 10px; padding-right: 10px"
          >
            <v-icon color="primary" size="22" class="mr-4"
            >fas fa-plus-circle
            </v-icon
            >
            Copy from
          </v-btn
          >
          <v-list-item-content>
            <v-row class="ma-0">
              <v-spacer></v-spacer>
              <v-select
                  v-model="copyFrom"
                  :items="clonableProfiles"
                  dense
                  value
                  hide-details
                  x-small
                  return-object
                  :menu-props="{ bottom: true, offsetY: true }"
                  item-text="configuration.device"
                  item-value="id"
                  class="mt-0"
                  style="max-width: 134px"
              >
                <!-- :style="isAdmin ? 'max-width: 125px' : 'max-width: 125px'" -->
                <template v-slot:item="{ item }">
                  <div class="py-2 char-lim-tabs page-rows-selection">
                    <div
                        class="py-2"
                        style="
                        font-size: 0.8125rem;
                        font-weight: 500;
                        line-height: 1rem;
                      "
                    >
                      {{
                        item.username ? item.configuration.device : "Default"
                      }}
                      <div
                          v-if="isAdmin && item.username"
                          style="display: inline; font-size: 12px"
                          class="pt-2 grey--text"
                      >
                        <!-- style="position: absolute;top: 20px;left: 15px;font-size: 12px" -->
                        ({{ item.username }})
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="page-rows-selection">
                    <div v-if="item.username">
                      {{ item.configuration.device }}
                    </div>
                    <div v-else>
                      <v-row class="mx-0">
                        Default
                        <!-- <div
                          style="font-size: 12px; margin-left: 4px"
                          class="grey--text"
                        >
                          (Default)
                        </div> -->
                      </v-row>
                    </div>
                  </div>
                </template>
              </v-select>
              <v-tooltip
                  v-if="$vuetify.breakpoint.width > 390"
                  max-width="300"
                  bottom
                  content-class="text-center"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                      v-if="$vuetify.breakpoint.width > 390"
                      v-on="on"
                      class="pt-1 mx-3"
                      small
                  >far fa-question-circle
                  </v-icon
                  >
                </template>
                <span class="text-center">
                  Create a new profile from an existing one. All settings will
                  be copied.
                </span>
              </v-tooltip>
            </v-row>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-checkbox
            v-model="dontAskAgain"
            class="general-checkbox statusText my-0 py-3 pl-4"
            off-icon="far fa-square"
            on-icon="fas fa-check-square"
            label="Don't ask again"
            hide-details
            dense
        ></v-checkbox>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import {SettingsService} from "@/services/ApiService";
import {defaultSettings} from "@/utilities/DefaultObjects";

export default {
  data: () => ({
    copyFrom: "Desktop",
    profileDeviceTypes: {
      Desktop: "Desktop",
      Laptop: "Laptop",
      Mobile: "Mobile",
      Tablet: "Tablet",
    },
    dontAskAgain: true,
  }),
  methods: {
    postNewProfile(configuration) {
      SettingsService.post(configuration)
          .then((response) => {
            this.$emit("new-profile-created");
            // this.$emit("refresh-user-profiles");
            if (response.data && response.data.configuration)
              this.$notifier.info(
                  `${response.data.configuration.device} profile created`
              );
            else
              this.$notifier.error(
                  "Profile was created but something went wrong on the server-side"
              );
          })
          .catch((error) => {
            this.$notifier.error("Couldn't create a new profile!");
          });
    },
    deleteProfileConfirmation(profile) {
      if (this.profilesCount < 2) {
        this.$notifier.error("You need to have at least one profile");
        return;
      }
      if (!profile.id) {
        this.$emit("delete-unsaved-profile", profile.configuration.device);
      }
      SettingsService.delete(profile.id)
          .then(() => {
            this.$emit("refresh-user-profiles");
            this.$notifier.info(
                `${profile.configuration.device} profile deleted`
            );
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Couldn't delete user profile.");
          });
    },
    addNewProfile() {
      // If a profile for this device type already exists, show an informative notification.
      let profileAlreadyExists;
      if (this.isAdmin) {
        profileAlreadyExists = this.profiles.some(
            (el) =>
                el.configuration.device == this.deviceType &&
                el.username == this.getUserInfo.name
        );
      } else {
        profileAlreadyExists = this.profiles.some(
            (el) => el.configuration.device == this.deviceType
        );
      }

      if (profileAlreadyExists) {
        let thisDevice =
            typeof this.deviceType == "string"
                ? this.deviceType.charAt(0).toLowerCase() + this.deviceType.slice(1)
                : "this device type";
        this.$notifier.error(`A profile for ${thisDevice} already exists`);
        // this.currentDeviceNotInList = false
        return;
      }

      if (this.copyFrom == "Desktop") {

        let desktopProfile = this.profiles.find(
            (el) => el.configuration.device == "Desktop"
        );

        let copyFromDefault = typeof this.copyFrom == "string" || typeof this.copyFrom == "object" && !this.copyFrom.hasOwnProperty('id')

        if (desktopProfile && !copyFromDefault) {
          this.copyFrom = desktopProfile;
        } else {
          this.copyFrom = {
            configuration: JSON.parse(JSON.stringify(defaultSettings)),
          };
        }
      }
      let newProfileConfiguration = JSON.parse(
          JSON.stringify(this.copyFrom.configuration)
      );
      // let newProfileConfiguration = JSON.parse(JSON.stringify(defaultSettings));
      newProfileConfiguration.device = this.deviceType || "Desktop";
      this.postNewProfile(newProfileConfiguration);
    },
    selectUserProfile(profile) {
      if (profile && profile.configuration.device) {
        if (this.dontAskAgain) {
          localStorage.setItem(
              "selected-device-type",
              profile.configuration.device
          );
        } else {
          localStorage.removeItem("selected-device-type");
        }
      }
      // TODO
      // Apply the selectoed profile settings + refresh the page (e.g if in priceguard when default settings values are used))
      this.$emit("profile-selected", profile);
      this.dialog = false;
    },
    handleDialogChange(ev) {
      this.$emit("input", ev);
    },
  },
  computed: {
    clonableProfiles() {
      return [...this.profiles, {configuration: defaultSettings}];
    },
    profilesCount() {
      return this.profiles.length;
    },
    textBig() {
      return this.text.length > 30 ? true : false;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    confidialogrmDialog: {
      get() {
        return this.profileSelectionDialog;
      },
      set(value) {
        this.$emit("mutate-profile-dialog", value);
      },
    },
    // settingsProfiles: {
    //   get() {
    //     return this.profiles;
    //   },
    //   set(value) {
    //     this.$emit("mutate-profile-dialog", value);
    //   },
    // },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    profiles: {
      type: Array,
      default: () => [],
    },
    deviceType: {
      type: String,
      default: null,
    },
    noProfilesExist: {
      type: Boolean,
      default: false,
    },
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    getUserInfo: {
      type: Object,
      default: () => {
      },
    },
  },
  mounted() {
    //     let parentScope = this
    //     document.body.onkeydown = function (ev) {
    //       if(parentScope.dialog && ev.keyCode == 13 && ev.which == 13) {
    //         parentScope.$emit('confirmation-event', true)
    //       }
    //     };
  },
  watch: {
    // Calculate if current device is in list of user profiles shown to the user
    // in order to hide the message "Profile for this type of device already exists"
    // profilesCount() {
    //   let currentDeviceNotInList = profiles.every(
    //     (el) => el.configuration.device != this.deviceType
    //   );
    //   if (currentDeviceNotInList)
    //     this.currentDeviceNotInList = currentDeviceNotInList;
    // },
    dialog(v) {
      if (!v) this.alreadyHaveThisProfile = false;
    },
  },
};
</script>
<style>
.ec-confirmation-dialog {
  box-shadow: none !important;
  overflow-y: hidden;
}

.ec-confirmation-dialog .v-card {
  background: #000000;
}

.ec-pageTitle {
  color: #fff;
  font-family: Dosis;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2.11px;
  text-transform: uppercase;
}
</style>
<style scoped>
.theme--dark .ec-dialog-text {
  color: whitesmoke;
}

.theme--light .ec-dialog-text {
  color: rgb(0, 0, 0, 0.85);
}

.ec-dialog-text {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}
</style>
